// Cookies forwarded with tracking events go to the sGTM container (a third party): never auth or session data.
const SENSITIVE_NAME = /^(token|role)$|token|session|auth|jwt|csrf|secret|password|^sid$/i;
const JWT_VALUE = /^eyJ[\w-]+\.[\w-]+\.[\w-]*$/;

export function isSensitiveTrackingCookie(name: string, value: unknown): boolean {
  if (SENSITIVE_NAME.test(name)) return true;
  return typeof value === 'string' && JWT_VALUE.test(value.trim());
}

export function safeTrackingCookies(cookies: unknown): Record<string, string> {
  if (!cookies || typeof cookies !== 'object' || Array.isArray(cookies)) return {};
  return Object.fromEntries(
    Object.entries(cookies as Record<string, unknown>).filter(
      ([name, value]) => typeof value === 'string' && !isSensitiveTrackingCookie(name, value),
    ),
  ) as Record<string, string>;
}
